import AccessDenied from "components/AccessDenied/index.js";
import PageContainer from "components/PageContainer/index.js";
import { useAuth } from "contexts/auth.context";
import Footer from "examples/Footer/index.js";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Route, Routes, useLocation } from "react-router-dom";
import AllSheets from "./components/AllSheets";
import Sheet from "./components/Sheet.js";
import { useEffect, useState } from "react";

function Sheets() {
  const [route, setRoute] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setRoute(null);
  }, [location]);

  const { checkPermission } = useAuth();

  if (
    Object.keys(checkPermission("category")).filter(
      (key) => checkPermission("category")[key],
    ).length === 0
  ) {
    return <AccessDenied type="page" />;
  }
  return (
    <DashboardLayout>
      <DashboardNavbar customRoute={route} />

      <PageContainer>
        <Routes>
          <Route
            index
            element={<AllSheets permissions={checkPermission("category")} />}
          />
          <Route
            path={"/:id"}
            element={
              !(
                checkPermission("category").get ||
                checkPermission("category").update
              ) ? (
                <AccessDenied type="half-page" />
              ) : (
                <Sheet
                  setRoute={setRoute}
                  permissions={checkPermission("category")}
                />
              )
            }
          />
        </Routes>
      </PageContainer>

      <Footer />
    </DashboardLayout>
  );
}

export default Sheets;
